export async function getDealerGroups(dealerId: string, ivideonIsAuth: any) {
  const params = new URLSearchParams();
  params.append("dealerId", dealerId);

  const url = `/internal-api/ivideon/groups?${params.toString()}`;
  if (ivideonIsAuth) {
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
        credentials: "include",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Ошибка: ", error);
    }
  }
}
